module.exports = __webpack_public_path__ + "static/media/ug_logo_xmas_hell.678139c4.png";